import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './Col.scss';
import { getMergedClassNames } from 'utils/HTMLUtils';

const rootClassName = styles.rootClassName;

class Col extends Component {
  toCssClasses(cols) {
    let classes = rootClassName;

    if (cols[0]) classes += ` col-xs-${cols[0]}`;
    if (cols[1]) classes += ` col-sm-${cols[1]}`;
    if (cols[2]) classes += ` col-md-${cols[2]}`;
    if (cols[3]) classes += ` col-lg-${cols[3]}`;
    if (cols[4]) classes += ` col-xl-${cols[4]}`;

    return classes;
  }

  render() {
    const gridClasses = getMergedClassNames([
      this.toCssClasses(this.props.cols || [12, 12, 12, 12, 12]),
      this.props.noPadding ? 'no-padding' : '',
      this.props.flex ? 'flex' : '',
      this.props.end ? 'end' : '',
      this.props.centralized ? 'centralized' : '',
      this.props.buttonActionsCol ? 'button-actions-col' : '',
      this.props.className,
    ]);
    return (
      <div
        className={gridClasses}
        style={{
          gap: this.props.gap ?? undefined,
          ...(this.props.style ?? {}),
        }}
      >
        {this.props.children}
      </div>
    );
  }
}

Col.propTypes = {
  cols: PropTypes.arrayOf(PropTypes.number),
  className: PropTypes.string,
  noPadding: PropTypes.bool,
  flex: PropTypes.bool,
  end: PropTypes.bool,
  centralized: PropTypes.bool,
  gap: PropTypes.string,
};

export default Col;
